module.exports = __webpack_public_path__ + "img/portraits_08_V.2b07d864.webp";